<template>
    <div>
        加氢站列表
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>